import { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { FileText, Download } from "lucide-react";

export default function DocumentsPage() {
  const [docs, setDocs] = useState([]);
  useEffect(() => { api.get("/documents").then((r) => setDocs(r.data)); }, []);

  const backend = process.env.REACT_APP_BACKEND_URL;

  const openDoc = async (d) => {
    if (!d.storage_path) return window.open(d.url, "_blank");
    // Authenticated fetch → blob → open
    try {
      const res = await fetch(`${backend}/api/files/${d.storage_path}`, { credentials: "include" });
      const blob = await res.blob();
      const url = URL.createObjectURL(blob);
      window.open(url, "_blank");
      setTimeout(() => URL.revokeObjectURL(url), 60000);
    } catch {
      // fallback
      window.location.href = `${backend}/api/files/${d.storage_path}`;
    }
  };

  return (
    <div className="p-6 md:p-10 max-w-5xl">
      <h1 className="heading text-3xl md:text-4xl">Documents</h1>
      <p className="text-sm text-muted-foreground mt-1">Deeds, agreements, and receipts for your plots.</p>
      <div className="mt-6 border border-border rounded-lg bg-card divide-y divide-border" data-testid="documents-list">
        {docs.length === 0 && <div className="p-6 text-sm text-muted-foreground">No documents yet.</div>}
        {docs.map((d) => (
          <button key={d.id} type="button" onClick={() => openDoc(d)} className="w-full p-4 flex items-center gap-3 hover:bg-secondary/40 transition-[background-color] duration-200 text-left" data-testid={`doc-${d.id}`}>
            <FileText size={16} className="text-primary" />
            <div className="flex-1 min-w-0">
              <div className="text-sm font-medium truncate">{d.title}</div>
              <div className="text-[10px] uppercase tracking-[0.2em] text-muted-foreground">{d.doc_type}{d.storage_path ? " · file" : " · link"}</div>
            </div>
            <Download size={14} className="text-muted-foreground" />
          </button>
        ))}
      </div>
    </div>
  );
}
